import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserGroceryBaggerGameProps {
    onComplete: () => void;
}

interface PhaserGroceryBaggerGameState {
}

const gameConfig: GameConfig = {
    title: "Grocery Bagger Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserGroceryBaggerGame extends React.Component<PhaserGroceryBaggerGameProps, PhaserGroceryBaggerGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserGroceryBaggerGameProps) {
        super(props);
        bindAllOfThis(this, PhaserGroceryBaggerGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserGroceryBaggerGame;



// WEBPACK FOOTER //
// ./src/games/GroceryBaggerGame/Main.tsx